export enum InternalAccessor {
  Disabled = '_disabled',
  HoverActions = '_hoverActions',
  Readonly = 'readonly', // It can be combined with `UrlExternal` or `UrlInternal` to make row not clickable */
  StaticActions = '_staticActions',
  SubRow = '_subRow',
  UrlExternal = '_urlExternal',
  UrlInternal = '_urlInternal',
}
